import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import { baseUrls } from '../appConstant';
import { catchError, retry } from 'rxjs/operators';
import {Observable, of} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  userToken = localStorage.getItem('userToken') ? localStorage.getItem('userToken') : '';
  constructor(private httpClient: HttpClient) { }

  getSurveyQuestions(): Observable<any>{
    let url = baseUrls['bill'] + 'userservice/survey/data';
    return this.httpClient.get(url);
  }

  postQuestionaireData(objToSend): Observable<any>{
    let url = baseUrls['bill'] + 'userservice/survey/save';
    return this.httpClient.post(url, objToSend,  {headers: { 'token': this.userToken}});
  }

  getUserSpecificUserSurveyData(userId){
    let url = baseUrls['bill'] + `userservice/survey/get-recommendation/${userId}`;
    return this.httpClient.get(url,  {headers: { 'token': this.userToken}});
  }
}
